import type WebSocket from 'ws';
import { startStreamingProxy } from './proxy/start-streaming-proxy.js';
import type { FirehoseMessageDeps } from './routing/firehose-message-deps.js';
import type { LogFn } from '../log.js';
import type { PreviewEnvironmentManager } from '../preview-environments/manager/manager.js';

export function createFirehoseMessageDeps(
  ws: WebSocket,
  log: LogFn,
  previewEnvironmentManager: PreviewEnvironmentManager,
): FirehoseMessageDeps {
  const pendingProxyBody = new Map<string, PendingStreamingProxy>();
  const earlyProxyBinaryBody = new Map<string, Uint8Array>();

  const deps: FirehoseMessageDeps = {
    ws,
    log,
    previewEnvironmentManager,
    pendingProxyBody,
    earlyProxyBinaryBody,
    startStreamingProxy: (pr) => startStreamingProxy(ws, log, pr),
  };

  return deps;
}
